/**
 * Business Club page: Бизнес-клуб — пространство общения и роста.
 * Static content, events to be added later.
 */

import { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Layout } from "../../components/layout/index.ts";
import { IconChevronRight } from "../../components/Icons.tsx";
import { getTelegram } from "../../lib/telegram.ts";

const BODY_TEXT = `Бизнес-клуб — это пространство общения и роста для людей,
которые занимаются делом, служат через свою профессию
и хотят строить бизнес, опираясь на библейские ценности.

Здесь мы:
• общаемся и знакомимся
• делимся жизненным и профессиональным опытом
• поддерживаем друг друга в решениях и вызовах
• размышляем о работе, ответственности и призвании
• учимся быть верными Богу в том, что нам доверено

Это не про конкуренцию и не про продажи.
Это про единство, честность и зрелость.

⸻

🙏 Зачем нужен бизнес-клуб в церкви?
• чтобы не разделять веру и повседневную жизнь
• чтобы учиться принимать решения с Богом
• чтобы поддерживать друг друга в пути
• чтобы возрастать как личности, семьи и служители

Бизнес — это тоже часть призвания,
и мы хотим проходить этот путь вместе.

⸻

🌱 Для кого:
• предприниматели
• руководители
• специалисты и самозанятые
• все, кто хочет расти и служить через свою работу

Если тебе важно, как ты живёшь, работаешь и ради чего,
мы будем рады видеть тебя в Бизнес-клубе.`;

function buildImageUrl(url: string | null | undefined): string | null {
  if (!url?.trim()) return null;
  if (url.startsWith("http")) return url;
  return url.startsWith("/") ? url : `/${url}`;
}

export function BusinessClubPage() {
  const navigate = useNavigate();
  const tg = getTelegram();
  const imageUrl = buildImageUrl("/content/bussiness-meet.jpg");

  useEffect(() => {
    if (!tg) return;
    tg.BackButton.show();
    const handleBack = () => {
      if (window.history.length > 1) {
        navigate(-1);
      } else {
        navigate("/");
      }
    };
    tg.BackButton.onClick(handleBack);
    return () => {
      tg.BackButton.offClick(handleBack);
      tg.BackButton.hide();
    };
  }, [tg, navigate]);

  return (
    <Layout>
      <h1 className="text-xl font-bold text-slate-800 mb-4">Бизнес-клуб</h1>

      {/* Hero image */}
      {imageUrl ? (
        <div className="aspect-[4/3] overflow-hidden rounded-2xl mb-4 shadow-sm border border-slate-100 ring-1 ring-slate-200/50 bg-slate-100">
          <img src={imageUrl} alt="" className="w-full h-full object-cover" />
        </div>
      ) : null}

      {/* Description */}
      <div className="rounded-2xl overflow-hidden bg-white/95 shadow-sm p-4 xs:p-5 border border-slate-100">
        <p className="text-slate-600 text-sm leading-relaxed whitespace-pre-wrap prose prose-slate prose-sm max-w-none">
          {BODY_TEXT}
        </p>
      </div>

      {/* Placeholder for future events */}
      <div className="mt-6 rounded-2xl overflow-hidden bg-white/80 backdrop-blur-sm shadow-sm p-6 text-center border border-slate-100">
        <p className="text-slate-500 text-sm font-medium uppercase tracking-wider">
          Скоро
        </p>
        <p className="text-slate-600 text-sm mt-1">
          Мероприятия Бизнес-клуба появятся здесь
        </p>
      </div>

      <div className="mt-6">
        <Link
          to="/schedule"
          className="flex items-center justify-between gap-3 py-4 px-4 rounded-xl bg-white/95 shadow-sm border border-slate-100 active:bg-slate-50 transition-colors no-underline text-inherit"
        >
          <span className="font-medium text-slate-800">
            Всё расписание на неделю
          </span>
          <IconChevronRight className="w-5 h-5 text-slate-300 flex-shrink-0" />
        </Link>
      </div>

      <div className="h-4" />
    </Layout>
  );
}
